import React from "react";
import { Content } from "../../components/light/Content";
import { Helmet } from "react-helmet";

export function TermScreen() {
  return (
    <Content>
      <Helmet>
        <style>
          {`.container-l192 {
                width: 100% !important;
                max-width: 1000px !important;
                margin: 0 auto !important;
                padding: 1rem !important;
                box-sizing: border-box !important;
            }
            ol {
                list-style-type: none;
                counter-reset: item;
                margin: 0;
                padding: 0;
            }

            ol>li {
                display: table;
                counter-increment: item;
                margin-bottom: 0.6em;
            }

            ol>li:before {
                font-size: 2em;
                font-weight: bold;
                content: counters(item, ".") ". ";
                display: table-cell;
                padding-right: 0.6em;
            }

            ol>li ol>li {
                margin: 0;
            }

            ol>li ol>li:before {
                font-size: 1.3em;
                font-weight: bold;
                content: counters(item, ".") " ";
            }

            ul li {
                list-style-type: none;
                margin: 10px 0;
            }

            p {
                line-height: 1.5rem;
            }

            * {
                font-family: Calibri, Arial, Helvetica, sans-serif;
            }

            h3 {
                font-size: 2rem;
            }`}
        </style>
      </Helmet>
      <div className="container-l192">
        <h1>Free Membership Agreement</h1>
        <p>(Updated on September 09, 2019)</p>
        <p>
          PLEASE READ THESE TERMS AND CONDITIONS CAREFULLY! PLEASE PAY ATTENTION
          TO PROVISIONS THAT EXCLUDE OR LIMIT LIABILITY AND TERMS OF GOVERNING
          LAW AND JURISDICTION, WHICH MAY APPEAR IN CAPITAL LETTERS.
        </p>
        <ol className="root">
          <li>
            <h3>ACCEPTANCE OF TERMS</h3>
            <p>
              WELCOME TO L192.COM'S FREE SERVICE (the "SERVICE"). The following
              sets forth the terms and conditions of the L192.COM Free
              Membership Agreement (this "Agreement") between you (“Member”) and
              the L192.COM company determined in accordance with this clause
            </p>
            <ol className="first-level">
              <li>
                <p>
                  ("L192.COM") under which L192.COM offers you access to and use
                  of the Service through the websites, mobile sites, mobile
                  applications and other portals owned, operated, branded or
                  made available by L192.COM to you from time to time relating
                  to the L192.COM e-commerce platforms. Your contract is with
                  Little Digital Co., Ltd. (known as LITTLEFASHION). As some or
                  part of the Service may be supported and provided by
                  affiliates of L192.COM, L192.COM may delegate some aspects of
                  the Service to its affiliates. Use of the Service indicates
                  that you accept the terms and conditions set forth below. If
                  you do not accept all of the terms and conditions, please do
                  not use the Service. BY COMPLETING THE REGISTRATION PROCESS
                  AND CLICKING THE "I AGREE" BUTTON, YOU ARE INDICATING YOUR
                  CONSENT TO BE BOUND BY THIS AGREEMENT AND PRIVACY POLICY
                  (DEFINED BELOW). The L192.COM Free Membership Agreement will
                  not take effect unless and until you have activated your
                  Account. Terms not defined in this Agreement shall bear the
                  same meaning as that contained in the Terms of Use.
                </p>
              </li>
              <li>
                <p>
                  L192.COM may amend this Agreement at any time by posting the
                  amended and restated Agreement on the Sites. The amended and
                  restated Agreement shall be effective immediately upon
                  posting. Posting by L192.COM of the amended and restated
                  Agreement and your continued use of the Service shall be
                  deemed to be acceptance of the amended terms.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <h3>THE SERVICE</h3>

            <ol className="first-level">
              <li>
                <p>
                  The Service will be offered free-of-charge for an unspecified
                  time period unless terminated in accordance with the terms of
                  this Agreement.
                </p>
              </li>
              <li>
                <p>
                  The Service will have the following core features (which may
                  be added to or modified, or suspended for scheduled or
                  unscheduled maintenance purposes, from time to time at the
                  sole discretion of L192.COM and notified to you) ("Free Member
                  Benefits"):
                  <ul className="letter">
                    <li>
                      a) Company Profile - allows each Member to display and
                      edit basic information about its business, such as year
                      and place of establishment, estimated annual sales, number
                      of employees, and products and services offered, etc.
                    </li>
                    <li>
                      b) Products - allows each Member to display and edit
                      descriptions, specifications and images.
                    </li>
                    <li>
                      c)Unlimited Buyer Trade Lead Posting - allows each Member
                      to post on the Sites for public display offers to buy
                      products and services from other users of the Sites.
                    </li>
                  </ul>
                </p>
              </li>
              <li>
                <p>
                  L192.COM may suspend or terminate all or part of the above
                  Free Member Benefits at any time in its sole discretion
                  without liability for any losses or damages arising out of or
                  in connection with such suspension or termination. L192.COM
                  reserves the right to charge for the Service or any feature or
                  functionality of the Service at any time in its sole
                  discretion.
                </p>
              </li>
              <li>
                <p>
                  Benefits, features and functions available to a Member may
                  vary for different countries and regions. No warranty or
                  representation is given that a particular feature or function
                  or the same type and extent of features and functions will be
                  available.
                </p>
              </li>
              <li>
                <p>
                  The availability of any transactional features and functions
                  on the Sites to any Member may be conditional on verification
                  of Member’s identity and/or its designated bank account by
                  L192.COM and/or its approved independent third parties.
                </p>
              </li>
              <li>
                <p>
                  L192.COM shall issue a Member ID and Password (the latter
                  shall be chosen by the Member during registration) to each
                  Member to access the Service through such Member's Account.
                  Each Member shall be solely responsible for maintaining the
                  confidentiality of its Member ID and Password and for all use
                  of and activities that occur under the Member ID and Password
                  (whether such use or activities are authorized or not). A set
                  of Member ID and Password is unique to a single Account and no
                  Member shall share, assign or permit the use of its Account,
                  Member ID or Password to another person, even to other
                  individuals within the Member's own business entity (where
                  applicable). Each Member acknowledges that sharing of its
                  Account with other persons, or allowing multiple users outside
                  of its business entity to use its Account (collectively,
                  "multiple use"), may cause irreparable harm to L192.COM and
                  each Member shall indemnify L192.COM against any loss or
                  damages (including but not limited to loss of profits)
                  suffered by L192.COM as a result of such multiple use of an
                  Account. Each Member hereby undertakes to notify L192.COM
                  immediately of any unauthorized use of its Account, Member ID
                  or Password or any other breach of security. Each Member
                  hereby agrees that L192.COM shall not be liable for any loss
                  or damages arising from the Member's failure to comply with
                  this paragraph.
                </p>
              </li>
              <li>
                <p>
                  L192.COM reserves the right to change, upgrade, modify, limit
                  or suspend the Service or any of its related functionalities
                  or applications at any time temporarily or permanently without
                  prior notice. L192.COM further reserves the right but shall
                  not be obliged to introduce new features, functionalities,
                  applications or conditions to the Service or to future
                  versions of the Service. All new features, functionalities,
                  applications, conditions, modifications, upgrades and
                  alterations shall be governed by this Agreement, unless
                  otherwise stated by L192.COM.
                </p>
              </li>
              <li>
                <p>
                  Each Member acknowledges that inability to use the Service
                  wholly or partially for whatever reason may have adverse
                  effects on its business. Each Member hereby agrees that in no
                  event shall L192.COM be liable to the Member or any third
                  parties for any inability to use the Service (whether due to
                  disruption, changes to or termination of the Service or
                  otherwise), any delays, inaccuracies, errors or omissions with
                  respect to any communications or transmission or delivery of
                  all or any part thereof, or any losses or damages (direct,
                  indirect, consequential or otherwise) arising from the use of
                  or inability to use the Service.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <h3>MEMBER RESPONSIBILITIES</h3>

            <ol className="first-level">
              <li>
                <p>
                  Each Member hereby represents, warrants and agrees to (a)
                  provide true, accurate, current and complete information about
                  itself and its business references as may be required by
                  L192.COM and (b) maintain and promptly amend all information
                  to keep it true, accurate, current and complete. To the extent
                  permitted under applicable laws, each Member hereby grants an
                  irrevocable, perpetual, worldwide and royalty-free,
                  sub-licensable (through multiple tiers) license to L192.COM to
                  display and use all information provided by such Member in
                  accordance with the purposes set forth in this Agreement and
                  to exercise the copyright, publicity, and database rights you
                  have in such material or information, in any media now known
                  or not currently known. Information that is protected under
                  data protection laws will only be used and kept in compliance
                  with those laws.
                </p>
              </li>
              <li>
                <p>
                  Each Member hereby represents, warrants and agrees that the
                  use by such Member of the Service and the Sites shall not:
                  <ul>
                    <li>
                      a) contain fraudulent information or make fraudulent
                      offers of items or involve the sale or attempted sale of
                      counterfeit or stolen items or items whose sales and/or
                      marketing is prohibited by applicable law, or otherwise
                      promote other illegal activities;
                    </li>
                    <li>
                      b) be part of a scheme to defraud other Members or other
                      users of the Sites or for any other unlawful purpose;
                    </li>
                    <li>
                      c) infringe or otherwise abet or encourage the
                      infringement or violation of any third party's copyright,
                      patent, trademarks, trade secret or other proprietary
                      right or rights of publicity and privacy or other
                      legitimate rights;
                    </li>
                    <li>
                      d) impersonate any person or entity, misrepresent yourself
                      or your affiliation with any person or entity;
                    </li>
                    <li>
                      e) violate any applicable law, statute, ordinance or
                      regulation (including without limitation those governing
                      export control, consumer protection, unfair competition,
                      anti-discrimination or false advertising);
                    </li>
                    <li>
                      f) contain information that is defamatory, libelous,
                      unlawfully threatening or unlawfully harassing;
                    </li>
                    <li>
                      g) contain information that is obscene or contain or infer
                      any pornography or sex-related merchandising or any other
                      content or otherwise promotes sexually explicit materials
                      or is otherwise harmful to minors;
                    </li>
                    <li>
                      h) promote discrimination based on race, sex, religion,
                      nationality, disability, sexual orientation or age;
                    </li>
                    <li>
                      i) contain any material that constitutes unauthorized
                      advertising or harassment (including but not limited to
                      spamming), invades anyone's privacy or encourages conduct
                      that would constitute a criminal offence, give rise to
                      civil liability, or otherwise violate any law or
                      regulation;
                    </li>
                    <li>
                      j) involve attempts to copy, reproduce, exploit or
                      expropriate L192.COM's various proprietary directories,
                      databases and listings;
                    </li>
                    <li>
                      k) involve any computer viruses or other destructive
                      devices and codes that have the effect of damaging,
                      interfering with, intercepting or expropriating any
                      software or hardware system, data or personal information;
                      and
                    </li>
                    <li>
                      l) involve any scheme to undermine the integrity of the
                      computer systems or networks used by L192.COM and/or any
                      user of the Service and no Member shall attempt to gain
                      unauthorized access to such computer systems or networks;
                    </li>
                    <li>
                      m) link directly or indirectly to or include descriptions
                      of goods or services or other materials that violate any
                      law or regulation or are prohibited under this Agreement
                      or the Terms of Use; or
                    </li>
                    <li>
                      n) otherwise create any liability for L192.COM or its
                      affiliates.
                    </li>
                  </ul>
                </p>
              </li>
              <li>
                <p>
                  Each Member represents, warrants and agrees that with regards
                  to information about or posted on behalf of any business
                  referee, it has obtained all necessary consents, approvals and
                  waivers from such referee to
                  <ul>
                    <li>(a) act as such Member's business referee;</li>
                    <li>
                      (b) to post and publish their contact details and
                      information, reference letters and comments on their
                      behalf; and
                    </li>
                    <li>
                      (c) that third parties may contact such business referees
                      to support claims or statements made about the Member.
                      Each Member further warrants that all reference letters
                      and comments are true and accurate and hereby waives all
                      requirements for such Member's consent to be obtained
                      before third parties may contact the business referees.
                    </li>
                  </ul>
                </p>
              </li>
              <li>
                <p>
                  Member shall not take any action which may undermine the
                  integrity of L192.COM's feedback system, such as leaving
                  positive feedback for himself using secondary Member IDs or
                  through third parties or by leaving unsubstantiated negative
                  feedback for another Member.
                </p>
              </li>
              <li>
                <p>
                  Each Member acknowledges and agrees that L192.COM reserves the
                  right to, but shall not be required to actively monitor nor
                  exercise any editorial control whatsoever over the content of
                  any message or other material or information created, obtained
                  or accessible through the Service. L192.COM does not endorse,
                  verify or otherwise certify the contents of any comments or
                  other material or information made by any Member. Each Member
                  is solely responsible for the contents of their communications
                  and may be held legally liable or accountable for the content
                  of their comments or other material or information.
                </p>
              </li>
              <li>
                <p>
                  Each Member represents, warrants and agrees that it has
                  obtained all necessary third party licenses and permissions
                  and shall be solely responsible for ensuring that any material
                  or information it posts on the Sites or provides to L192.COM
                  or authorizes L192.COM to display does not violate the
                  copyright, patent, trademark, trade secrets or any other
                  personal or proprietary rights of any third party or is posted
                  with the permission of the owner(s) of such rights. Each
                  Member further represents, warrants and agrees that it has the
                  right and authority to sell, distribute or offer to sell or
                  distribute the products described in the material or
                  information it posts on the Sites or provides to L192.COM or
                  authorizes L192.COM to display.
                </p>
              </li>
              <li>
                <p>
                  If any Member breaches the representations, warranties and
                  covenants of paragraphs 3.1, 3.2, 3.3, 3.4, 3.5 or 3.6 above,
                  or if L192.COM has reasonable grounds to believe that such
                  Member is in breach of such representations, warranties and
                  covenants, or if upon complaint or claim from any other Member
                  or third party, L192.COM has reasonable grounds to believe
                  that such Member has willfully or materially failed to perform
                  its contract with such third party including without
                  limitation where a Member who supplies products or services
                  using the Sites and Services has failed to deliver any items
                  ordered by such third party after receipt of the purchase
                  price, or where such Member has delivered the items that
                  materially fail to meet the terms and descriptions outlined in
                  its contract with such third party, or if L192.COM has
                  reasonable grounds to believe that such Member has used a
                  stolen credit card or other false or misleading information in
                  any online transaction, L192.COM has the right to suspend or
                  terminate the Service and all Free Member Benefits with
                  respect to such Member without compensation and without
                  liability for any losses or damages arising out of or in
                  connection with such suspension or termination, and restrict
                  or refuse any and all current or future use of the Service or
                  any other services that may be provided by L192.COM. Further,
                  L192.COM reserves the right in its sole discretion to place
                  restrictions on the number of product listings that a Member
                  can post on the Sites for such duration as L192.COM may
                  consider appropriate, and to remove any material it reasonably
                  believes that is unlawful, could subject L192.COM to
                  liability, violates this Agreement or the Terms of Use or is
                  otherwise found inappropriate in L192.COM's opinion. L192.COM
                  reserves the right to cooperate fully with governmental and
                  regulatory authorities, law enforcement bodies, private
                  investigators and/or injured third parties in the
                  investigation of any suspected criminal or civil wrongdoing.
                  Further, to the extent permitted under applicable laws and
                  policies, L192.COM may disclose the Member's identity, contact
                  information and/or information regarding the Member's
                  account(s), transactions or activities carried out on or via
                  the Sites, if requested by a government, regulatory or law
                  enforcement body or an injured third party, or as a result of
                  a subpoena or other legal action, and L192.COM shall not be
                  liable for damages or results thereof and Member agrees not to
                  bring any action or claim against L192.COM for such
                  disclosure. In connection with any of the foregoing, L192.COM
                  may suspend or terminate the Account of any Member as L192.COM
                  deems appropriate in its sole discretion.
                </p>
              </li>
              <li>
                <p>
                  Each Member agrees to indemnify L192.COM, its employees,
                  agents and representatives and to hold them harmless, from any
                  and all losses, claims and liabilities (including legal costs
                  on a full indemnity basis) which may arise from its
                  submissions, posting of materials or deletion thereof, from
                  such Member's use of the Service or from such Member's breach
                  of this Agreement or the Terms of Use. Each Member further
                  agrees that L192.COM is not responsible, and shall have no
                  liability to it or anyone else for any material posted by such
                  Member or third parties, including fraudulent, untrue,
                  misleading, inaccurate, defamatory, offensive or illicit
                  material and that the risk of damage from such material rests
                  entirely with each Member. L192.COM reserves the right; at its
                  own expense, to assume the exclusive defense and control of
                  any matter otherwise subject to indemnification by the Member,
                  in which event the Member shall cooperate with L192.COM in
                  asserting any available defenses.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <h3>LIMITATION OF LIABILITY</h3>
            <ol className="first-level">
              <li>
                <p>
                  TO THE MAXIMUM EXTENT PERMITTED BY LAW, THE SERVICE IS
                  PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS, AND L192.COM
                  HEREBY EXPRESSLY DISCLAIMS ANY AND ALL WARRANTIES, EXPRESS OR
                  IMPLIED, INCLUDING BUT NOT LIMITED TO ANY WARRANTIES OF
                  CONDITION, QUALITY, DURABILITY, PERFORMANCE, ACCURACY,
                  RELIABILITY, MERCHANTABILITY OR FITNESS FOR A PARTICULAR
                  PURPOSE OR NON-INFRINGEMENT. ALL SUCH WARRANTIES,
                  REPRESENTATIONS, CONDITIONS, UNDERTAKINGS AND TERMS ARE HEREBY
                  EXCLUDED.
                </p>
              </li>
              <li>
                <p>
                  TO THE MAXIMUM EXTENT PERMITTED BY LAW, L192.COM MAKES NO
                  REPRESENTATIONS OR WARRANTIES ABOUT THE VALIDITY, ACCURACY,
                  RELIABILITY, QUALITY, STABILITY, COMPLETENESS OR CURRENTNESS
                  OF ANY INFORMATION PROVIDED ON OR THROUGH THE SITES.
                </p>
              </li>
              <li>
                <p>
                  Any material downloaded or otherwise obtained through the
                  access to or use of the Sites or Service is done at each
                  Member's sole discretion and risk and each Member is solely
                  responsible for any damage to its computer system or any loss
                  of data that results from the download of any such material.
                  No advice or information, whether oral or written, obtained by
                  any Member from L192.COM or through or from the Service shall
                  create any warranty not expressly stated in this Agreement.
                </p>
              </li>
              <li>
                <p>
                  The Sites may make available to User services or products
                  provided by independent third parties. No warranty or
                  representation is made with regard to such services or
                  products. In no event shall L192.COM or its affiliates be held
                  liable for any such services or products.
                </p>
              </li>
              <li>
                <p>
                  Under no circumstances shall L192.COM be held liable for an
                  delay or failure or disruption of the Service resulting
                  directly or indirectly from acts of nature, forces or causes
                  beyond its reasonable control, including without limitation,
                  Internet failures, computer, telecommunications or any other
                  equipment failures, electrical power failures, strikes, labor
                  disputes, riots, insurrections, civil disturbances, shortages
                  of labor or materials, fires, flood, storms, explosions, Acts
                  of God, war, governmental actions, orders of domestic or
                  foreign courts or tribunals or non-performance of third
                  parties.
                </p>
              </li>
              <li>
                <p>
                  To the extent permitted by law, L192.COM shall not be liable
                  for any special, direct, indirect, punitive, incidental or
                  consequential damages or any damages whatsoever (including but
                  not limited to damages for loss of profits or savings,
                  business interruption, loss of information), whether in
                  contract, negligence, tort or otherwise or any other damages
                  resulting from any of the following:
                  <ul className="letter">
                    <li>a) the use or the inability to use the Service;</li>
                    <li>
                      b) any defect in goods, samples, data, information or
                      services purchased or obtained from a Member or a
                      third-party service provider through the Sites;
                    </li>
                    <li>
                      c) unauthorized access by third parties to data or private
                      information of any Member;
                    </li>
                    <li>
                      d) statements or conduct of any user of the Sites; or
                    </li>
                    <li>
                      e) any other matter relating to the Sites or Service
                      however arising, including negligence.
                    </li>
                  </ul>
                </p>
                <p>
                  PRIVACY Please review the following policies to know how we
                  use and protect your personal information when you use
                  Services of the relevant Site:
                  <ul className="letter">
                    <li>
                      a) for Users who access or use Sites relating to the L192
                      e-commerce platform, the L192.COM Privacy Policy.
                      (collectively, the “Privacy Policy”).
                    </li>
                  </ul>
                </p>
              </li>
            </ol>
          </li>
          <li>
            <h3>INTELLECTUAL PROPERTY RIGHTS</h3>

            <ol className="first-level">
              <li>
                <p>
                  L192.COM is the sole owner or lawful licensee of all the
                  rights to the Service. The Service embodies trade secrets and
                  intellectual property rights protected under worldwide
                  copyright and other laws. All title, ownership and
                  intellectual property rights in the Service shall remain with
                  L192.COM, its affiliates or licensors, as the case may be. All
                  rights not otherwise claimed under this Agreement or by
                  L192.COM are hereby reserved.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <h3>PRODUCT LISTING POLICY</h3>

            <ol className="first-level">
              <li>
                <p>
                  You may not post or sell any item that is restricted or
                  prohibited by a federal, state or local law in any country or
                  jurisdiction; thus the selling or posting of items may be
                  prohibited because of laws outside of the jurisdiction where
                  you reside. Below, we have listed some categories of
                  prohibited or restricted items. HOWEVER, THIS LIST IS NOT
                  INTENDED TO BE EXHAUSTIVE; YOU, AS THE SELLER, ARE RESPONSIBLE
                  FOR ENSURING THAT YOU ARE NOT POSTING AN ITEM THAT IS
                  PROHIBITED BY LAW IN ANY JURISDICTION. Unless otherwise
                  indicated and annotated accordingly below, the list of
                  prohibited or restricted items as listed shall be applicable
                  to L192 app and L192 Website.
                </p>
              </li>
              <li>
                <p>
                  L192.COM has chosen to also prohibit the posting of items
                  which may not be restricted or prohibited by law but are
                  nonetheless controversial including:
                  <ul className="letter">
                    <li>
                      (a) Items that encourage illegal activities (e.g. lock
                      pick tools, synthetic urine for cheating drug tests);
                    </li>
                    <li>
                      (b) Items that are racially, religiously or ethnically
                      derogatory, or that promote hatred, violence, racial or
                      religious intolerance;
                    </li>
                    <li>(c) Giveaways, lotteries, raffles, or contests;</li>
                    <li>
                      (d) Stocks, bonds, investment interests, and other
                      securities;
                    </li>
                    <li>
                      (e) Pornographic materials or items that are sexual in
                      nature;
                    </li>
                    <li>
                      (f) Items that do not offer a physical product or service
                      for sale, such as digital currencies and advertisements
                      solely for the purpose of collecting user information.
                    </li>
                  </ul>
                </p>
              </li>
              <li>
                <p>
                  L192.COM, in its sole and exclusive discretion, reserves the
                  right to impose additional restrictions and prohibitions.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <h3>GENERAL</h3>

            <ol className="first-level">
              <li>
                <p>
                  This Agreement and the Terms of Use constitute the entire
                  agreement between the Member and L192.COM with respect to and
                  governs the use of the Service, superseding any prior written
                  or oral agreements in relation to the same subject matter
                  herein.
                </p>
              </li>
              <li>
                <p>
                  L192.COM and the Member are independent contractors, and no
                  agency, partnership, joint venture, employee-employer or
                  franchiser-franchisee relationship is intended or created by
                  this Agreement.
                </p>
              </li>
              <li>
                <p>
                  If any provision of this Agreement is held to be invalid or
                  unenforceable, such provision shall be struck and the
                  remaining provisions shall be enforced.
                </p>
              </li>
              <li>
                <p>
                  Headings are for reference purposes only and in no way define,
                  limit, construe or describe the scope or extent of such
                  section.
                </p>
              </li>
              <li>
                <p>
                  L192.COM's failure to enforce any right or failure to act with
                  respect to any breach by a Member under this Agreement will
                  not waive that right nor waive L192.COM's right to act with
                  respect with subsequent or similar breaches.
                </p>
              </li>
              <li>
                <p>
                  L192.COM shall have the right to assign this Agreement
                  (including all of its rights, titles, benefits, interests, and
                  obligations and duties in this Agreement) to any person or
                  entity (including any affiliates of L192.COM). The Member may
                  not assign, in whole or part, this Agreement to any person or
                  entity.
                </p>
              </li>
              <li>
                <p>
                  THIS AGREEMENT SHALL BE GOVERNED BY THE LAWS OF THE KINGDOM OF
                  CAMBODIA.
                </p>
              </li>
              <li>
                <p>
                  If there is any conflict between the English version and
                  another language version of this Agreement, the English
                  version shall prevail.
                </p>
              </li>
            </ol>
          </li>
        </ol>
      </div>
    </Content>
  );
}
